import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setAuthLoading } from '../slice/authSlice'; // Adjust path if needed

const AppInitializer = () => {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setAuthLoading(false)); // Signal that auth loading is done (cookie read done)
    }, [dispatch]);

    return null;
};


export default AppInitializer;
